import classNames from 'classnames';
import React, { FC, useCallback, useMemo } from 'react';
import LanguageButtonSwitcher from '../../../LanguageButtonSwitcher/LanguageButtonSwitcher';
import { IMultiLanguageTextAreaHeaderProps } from '../../types';
import { LOCALES } from 'src/constants/main';
import Text, { TEXT } from 'src/view/components/Text/Text';
import './style.scss';

const MultiLanguageTextAreaHeader: FC<IMultiLanguageTextAreaHeaderProps> = ({
  textAreaRef,
  title,
  titleTooltip,
  currentLanguage,
  changeCurrentLanguage,
  required,
  disabled,
  validation,
  headerClassName,
  titleClassName,
}: IMultiLanguageTextAreaHeaderProps): JSX.Element => {
  const setFocus = useCallback(() => {
    if (textAreaRef.current) textAreaRef.current.focus();
  }, [textAreaRef]);

  const onChangeCurrentLanguage = useCallback(
    (btnLocale: LOCALES | undefined) => {
      changeCurrentLanguage(btnLocale);
      if (title) setFocus();
    },
    [title]
  );

  const className = useMemo((): string => {
    return classNames('multi-language-text-area-header', { 'multi-language-text-area-header_without-title': !title }, headerClassName);
  }, [title, headerClassName]);

  return (
    <div onClick={title ? undefined : setFocus} className={className}>
      <Text
        type={TEXT.BLOCK_HEADER}
        text={title}
        defaultValue=""
        required={required}
        disabled={disabled}
        className={titleClassName}
        tooltip={titleTooltip}
      />
      <LanguageButtonSwitcher language={currentLanguage} setLanguage={onChangeCurrentLanguage} validation={validation} />
    </div>
  );
};

export default MultiLanguageTextAreaHeader;
